import React from 'react';
import Accordion from '../components/Accordion';
import GrandOpen from './news/GrandOpen';
import RainyDay from './news/RainyDay';




const News = () => {
   return (
      <div id='News'>
         <div className='inner'>
            <GrandOpen activeAccordion={true} />
            <RainyDay />
            <Accordion />
         </div>
      </div>
   );
};

export default News;